export default __webpack_public_path__ + "static/media/premiumBadge.9509dbb1.png";